import { render, staticRenderFns } from "./PotentialCustomerProfileDetailsView.vue?vue&type=template&id=d356fbf4&scoped=true&"
import script from "./PotentialCustomerProfileDetailsView.vue?vue&type=script&lang=js&"
export * from "./PotentialCustomerProfileDetailsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d356fbf4",
  null
  
)

export default component.exports